export default __webpack_public_path__ + "assets/86a8bd75b6f88a0019da43eb124ae9bd/08.jpg";